module.exports = __webpack_public_path__ + "img/top4.68d4cb18.svg";